module.exports = __webpack_public_path__ + "static/media/gps-localization-interface-symbol.d980bff0.svg";